import { Link } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import { useTranslation } from "react-i18next";
import LanguageSelector from "../LanguageSelector";

/**
 * Top bar for the admin layout: sits in the right column next to the sidebar.
 * Shows back link, language, user, and logout.
 */
const AdminTopBar = () => {
  const { instance, accounts } = useMsal();
  const { t } = useTranslation();

  const handleLogout = () => {
    instance.logoutPopup();
  };

  return (
    <header className="flex-shrink-0 h-14 px-4 sm:px-6 flex items-center justify-between bg-white border-b border-gray-200 shadow-sm">
      <Link
        to="/"
        className="text-sm font-medium text-gray-600 hover:text-[#b5a666] transition-colors"
      >
        ← {t("admin_back_to_site")}
      </Link>
      <div className="flex items-center gap-4 text-gray-700">
        <LanguageSelector />
        {accounts.length > 0 && (
          <>
            <div className="hidden sm:flex items-center gap-2">
              <div className="w-8 h-8 rounded-full bg-gradient-to-r from-[#cabb78] to-[#b5a666] flex items-center justify-center ring-2 ring-gray-100">
                <span className="text-white text-sm font-medium">
                  {accounts[0]?.username?.charAt(0).toUpperCase()}
                </span>
              </div>
              <span className="text-sm font-medium text-gray-700">
                {accounts[0]?.username?.split("@")[0]}
              </span>
            </div>
            <button
              type="button"
              onClick={handleLogout}
              className="inline-flex items-center px-3 py-1.5 rounded-lg text-sm font-medium text-gray-600 hover:text-gray-900 hover:bg-gray-100 transition-colors"
            >
              {t("Logout")}
            </button>
          </>
        )}
      </div>
    </header>
  );
};

export default AdminTopBar;
